import { render, staticRenderFns } from "./buyCounp.vue?vue&type=template&id=a552d9c4&scoped=true&lang=true&"
import script from "./buyCounp.vue?vue&type=script&lang=js&"
export * from "./buyCounp.vue?vue&type=script&lang=js&"
import style0 from "./buyCounp.vue?vue&type=style&index=0&id=a552d9c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a552d9c4",
  null
  
)

export default component.exports